module.exports = __webpack_public_path__ + "static/dl1-iphone-2e433d6faf295deb1e0763c1ed7df87b.png";